"use client";

import { Checkbox } from "@upstageai/ui";

interface CheckboxWithLabelProps {
  id: string;
  label: React.ReactNode;
  labelClassName?: string;
  containerClassName?: string;
  isChecked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export function CheckboxWithLabel({
  id,
  label,
  labelClassName,
  containerClassName,
  isChecked,
  disabled,
  onChange,
  ...checkboxProps
}: CheckboxWithLabelProps) {
  return (
    <div className={`flex items-center space-x-2 ${containerClassName || ""}`}>
      <Checkbox
        id={id}
        checked={isChecked}
        onCheckedChange={onChange}
        disabled={disabled}
        className="flex size-[14px] items-center justify-center"
        {...checkboxProps}
      />
      <label
        htmlFor={id}
        className={`small cursor-pointer text-muted-dark peer-disabled:cursor-not-allowed peer-disabled:opacity-70 ${labelClassName || ""}`}
      >
        {label}
      </label>
    </div>
  );
}
